import { FC } from 'react';
import styled from 'styled-components';
import { TopDecorColor } from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';

const AltroButtonStatsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 28px 20px;
  background: linear-gradient(160deg, rgba(163, 27, 27, 0.1) 0%, rgba(10, 10, 10, 0.55) 100%);
  border: 1px solid rgba(163, 27, 27, 0.3);
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  gap: 8px;
  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(163, 27, 27, 0.7);
    box-shadow: 0 8px 28px rgba(163, 27, 27, 0.18);
  }

  .altro-button-stats-title {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    color: rgba(255, 255, 255, 0.92);
    letter-spacing: 4px;
    text-transform: uppercase;
    text-align: center;
  }

  .altro-button-stats-subtitle {
    font-size: 11px;
    font-weight: 500;
    margin: 0;
    color: rgba(163, 27, 27, 0.8);
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }
`;

interface AltroButtonStatsProps {
  title: string;
  onClick: () => void;
}

const AltroButtonStats: FC<AltroButtonStatsProps> = ({ title, onClick }) => {
  return (
    <AltroButtonStatsContainer className="altro-button-stats-container" onClick={onClick}>
      <TopDecorColor />
      <h3 className="altro-button-stats-title">{title}</h3>
      <span className="altro-button-stats-subtitle">Vedi statistiche →</span>
    </AltroButtonStatsContainer>
  );
};

export default AltroButtonStats;
